// @flow @jsx h
import { Component, h } from 'preact'

import styles from './index.css'
import { SerumResponsivePicture, HtmlContent } from '@nrk/dh-feature-components'

type Props = {
  byline: string,
  bylinebilde: string,
  load: boolean
}

export class Byline extends Component<Props> {
  render () {
    const { byline, bylinebilde, load } = this.props
    return <div class={styles.byline}>
      <div class={styles.byline__content}>
        <figure class={styles.byline__image} aria-hidden>
          <SerumResponsivePicture
            id={bylinebilde}
            alt={''}
            sizes={'150px'}
            ratio={'1:1'}
            load={load} />
        </figure>
        <HtmlContent content={byline} type={'span'} />
        <span class={styles.byline__jobTitle}>Journalist</span>
      </div>
    </div>
  }
}
